import { render, staticRenderFns } from "./setUpTeacher.vue?vue&type=template&id=618bb8be"
import script from "./setUpTeacher.vue?vue&type=script&lang=js"
export * from "./setUpTeacher.vue?vue&type=script&lang=js"
import style0 from "./setUpTeacher.vue?vue&type=style&index=0&id=618bb8be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports